import { Event } from '../Event.type';

export interface EventStatusResultFetch {
  eventId?: number | string;
  search?: string;
  ids?: Array<number>;
  page?: number | string;
  orderOffset?: number | string;
}

export interface EventStatusFetchFilter {
  ids?: Array<number>;
  offset_order?: number | string;
}
export interface EventStatusFetchParams {
  search?: string;
  page?: number | string;
  filter: EventStatusFetchFilter;
}

export interface SimpleEventStatus {
  id: number;
  name: string;
  altName?: string;
}

export enum EventStatusCode {
  COMMUNICATION_REJECT = 'COMMUNICATION_REJECT',
  PRE_INTERVIEW_REJECT = 'PRE_INTERVIEW_REJECT',
  INTERVIEW_REJECT = 'INTERVIEW_REJECT',
  PRE_INTERVIEW_PLANNED = 'PRE_INTERVIEW_PLANNED',
  INTERVIEW_PLANNED = 'INTERVIEW_PLANNED',
}

export interface EventStatus extends SimpleEventStatus {
  color?: string;
  code: EventStatusCode;
  event: Event;
  order: number;
  needAction: boolean;
  hasPlanningTime: boolean;
}
